import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { setOnUnauthorized } from "@flame/shared/api";
import { AuthProvider } from "@flame/shared/auth";
import { ToastViewport } from "@flame/shared/ui";
import { routes } from "./routes.js";
import "./styles.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000 },
  },
});

export const router = createBrowserRouter(routes);

// Wire 401 → redirect to /login.
// Do NOT invalidate ["me"] here: invalidate triggers a refetch which 401s
// again → onUnauthorized fires again → infinite loop on /login. Clear the
// cached identity once (so AuthProvider stops showing the old user) and let
// the next mount re-probe naturally if needed.
setOnUnauthorized(() => {
  queryClient.setQueryData(["me"], undefined);
  void router.navigate("/login", { replace: true });
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <ToastViewport />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
